import { encodeOAuthState } from '@modules/integrationsV2/utils/encodeOAuthState';
import {
  IntegrationChannelType,
  IntegrationDirection,
  IntegrationType,
} from 'generated/graphql';

interface GetOAuthRedirectionURLOptions {
  oAuthURL: string;
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
  tenantSlug?: string;
  integrationID?: string;
}

export const getOAuthRedirectionURL = ({
  oAuthURL,
  tenantSlug,
  channelType,
  integrationType,
  integrationID,
}: GetOAuthRedirectionURLOptions) => {
  const redirectURI = `${window.location.origin}/settings/integrations`;
  const oAuthState = encodeOAuthState({
    channelType,
    direction: IntegrationDirection.Inbound,
    data: { tenantSlug },
    integrationType,
    integrationID,
  });

  return `${oAuthURL}&redirect_uri=${redirectURI}&state=${oAuthState}`;
};
